import { Images } from "Components/Images";
import RetainOverlayTrigger from "Components/RetainOverlayTrigger";
import IParentProps from "Interfaces/Props/IParentProps";
import React from "react";
import { Badge, Image } from "react-bootstrap";

function getTooltip(tag: string) {
	switch(tag) {
		case "Limited":
			return (<span className="my-tooltip"><p>This student will not be added to the regular gacha pool after their banner.</p>
			<p>Their elephs may appear in the Expert Permit shop but the student can not be claimed from there.</p></span>)
		case "Fes Limited":
			return (<span className="my-tooltip">
				<p>This student will not be added to the regular gacha pool after their banner.</p>
				<p>Instead, they will be in a "Fes Pool" during the biannual Fes Banners. However, if they are not the Banner student, they are not sparkable and you will need to rely on getting them offrate.</p>
				<p>Their elephs may appear in the Expert Permit shop but the student can not be claimed from there.</p>
			</span>)
		case "Always": return "ALWAYS farm regardless of ongoing Events. Do them daily!";
		case "Anytime": return "Worth farming even during events. Your call.";
		case "Wait":
		case "TBA": return "Midokuni is lazy";
		case "Enabler":
			return <span className="my-tooltip">
				<p>A term that I use to replace "Must Get"</p>
				<p>I did this because we're at an age where no one is truly "Must Get" since everyone can get replaced. Enabler is the term i decided to use because these students will "Enable" you to easily clear higher difficulties than you otherwise couldnt</p>
				<p>This does not mean they are must get but they could enable to clear something.</p>
			</span>;
		case "Explosive":
		case "explosive":
			return (<Images.Armor color="Red"/>);
		case "Light":
		case "LightArmor":
		case "light":
			return (<Images.Armor color="Red"/>);
		case "HeavyArmor":
		case "Heavy":
		case "heavy":
			return (<Images.Armor color="Yellow"/>);
		case "Piercing":
		case "piercing":
			return (<Images.Armor color="Yellow"/>);
		case "Mystic":
		case "mystic":
			return (<Images.Armor color="Blue"/>);
		case "Unarmed":
		case "Special":
		case "special":
			return (<Images.Armor color="Blue"/>);
		case "ElasticArmor":
		case "Elastic":
		case "elastic":
			return (<Images.Armor color="Purple"/>);
		case "Sonic":
		case "sonic":
			return (<Images.Armor color="Purple"/>);
	
	}
	return undefined;
}
export function TagBadge(props: IParentProps & {pill?: boolean, pretext?: string, posttext?: string}) {
	const {pill, pretext, posttext} = props;
	const child = props.children?.toString() ?? "";
	const ThisBadge = (<TooltiplessTagBadge {...props}>{props.children}</TooltiplessTagBadge>);
	const tt = getTooltip(child);
	if (typeof(tt) === "undefined") return ThisBadge;
	console.log(tt, child)
	return (<RetainOverlayTrigger
		placement="top"
		overlay={<span id={child+"-tooltip"}>{tt}</span>}>
			<span>{ThisBadge}</span>
	</RetainOverlayTrigger>);
}
function TooltiplessTagBadge(props: IParentProps & {pill?: boolean, pretext?: string, posttext?: string}) {
	const {pill, pretext, posttext} = props;
	const child = props.children?.toString() ?? "";
	switch(child) {
		case "Hina in a Dress":
		case "Hina":
		case "Platinum":
			return (<Badge className="tag-badge" pill={pill} style={{marginRight: 5}} bg="violet">{props.children}</Badge>);
		case "Wait":
			return (<Badge className="tag-badge" pill={pill} style={{marginRight: 5}} bg="dull-violet">{props.children}</Badge>);
		case "S-":
			return (<Badge className="tag-badge" pill={pill} bg="violet">{pretext}{props.children}{posttext}</Badge>);
		case "No":
		case "Skip":
			return (<Badge className="tag-badge" pill={pill} style={{marginRight: 5}} bg="danger">{props.children}</Badge>);
		case "Anytime":
		case "Limited":
			return (<Badge className="tag-badge" pill={pill} style={{marginRight: 5}}>{props.children}</Badge>);
		case "Fes Limited":
		case "Almost Must Get":
		case "Always":
		case "Enabler":
		case "Must Get":
			return (<Badge className="tag-badge" pill={pill} style={{marginRight: 5}} bg="success">{props.children}</Badge>)
		case "A":
			return (<Badge className="tag-badge" bg="primary">{props.children}</Badge>);
		case "UE":
			return (<Badge className="tag-badge" style={{marginRight: 5}} pill bg="primary"><Images.UE />{pretext}{props.children}</Badge>);
		case "Gold":
			return (<Badge className="tag-badge" pill={pill} style={{marginRight: 5}} bg="dull-yellow">{props.children}</Badge>);
		case "Bronze":
			// TODO: Make a badge for Bronze
			return (<Badge className="tag-badge" pill={pill} style={{marginRight: 5}} bg="danger">{props.children}</Badge>);
		case "Explosive":
		case "explosive":
			return (<Badge className="tag-badge" pill={pill} bg="danger">Explosive</Badge>);
		case "Light":
		case "LightArmor":
		case "light":
			return (<Badge className="tag-badge" pill={pill} bg="danger">Light</Badge>);
		case "HeavyArmor":
		case "Heavy":
		case "heavy":
			return (<Badge className="tag-badge" pill={pill} bg="warning">Heavy</Badge>);
		case "Piercing":
		case "piercing":
			return (<Badge className="tag-badge" pill={pill} bg="warning">Piercing</Badge>);
		case "Mystic":
		case "mystic":
			return (<Badge className="tag-badge" pill={pill} bg="primary">Mystic</Badge>);
		case "Unarmed":
		case "Special":
		case "special":
			return (<Badge className="tag-badge" pill={pill} bg="primary">Special</Badge>);
		case "ElasticArmor":
		case "Elastic":
		case "elastic":
			return (<Badge className="tag-badge" pill={pill} bg="violet">Elastic</Badge>);
		case "Sonic":
		case "sonic":
			return (<Badge className="tag-badge" pill={pill} bg="violet">Sonic</Badge>);
	
		case "Outdoors":
		case "Field":
			return (<Badge className="tag-badge" pill={pill} style={{marginRight: 5}} bg="dull-yellow"><Image style={{height:18, marginRight: 2, position:"relative", top:-2}} src="/img/Terrain_Outdoor.png"></Image>{props.children}</Badge>);
		case "Indoor":
		case "Indoors":
			return (<Badge className="tag-badge" pill={pill} style={{marginRight: 5}} bg="primary"><Image style={{height:18, marginRight: 2, position:"relative", top:-2}} src="/img/Terrain_Indoor.png"></Image>{props.children}</Badge>);
		case "Street":
		case "Urban":
			return (<Badge className="tag-badge" pill={pill} style={{marginRight: 5}} bg="violet"><Image style={{height:18, marginRight: 2, position:"relative", top:-2}} src="/img/Terrain_Street.png"></Image>{props.children}</Badge>);
		case "When you simp":
		case "TOR":
			return (<Badge className="tag-badge" style={{marginRight: 5}} pill bg="danger">{props.children}</Badge>);
		case "INS":
		case "EXT":
			return (<Badge className="tag-badge" style={{marginRight: 5}} pill bg="primary">{props.children}</Badge>);
		case "HC":
		case "VH":
		case "H":
		case "N":
			return (<Badge className="tag-badge" style={{marginRight: 5}} pill bg="dark">{props.children}</Badge>);
		default:
			if (child.match(/(\d+[\*☆]?\s*)?UE\s*\d+[\*☆]/gi))
				return (<Badge className="tag-badge" style={{marginRight: 5}} pill bg="primary"><Image style={{height:18, marginRight: 2, position:"relative", top:-2}} src="/img/Common_Icon_CharacterWeapon_off.png"></Image>{props.children}</Badge>);
			return (<Badge className="tag-badge" pill={pill} style={{marginRight: 5}} bg="secondary">{props.children}</Badge>);
	}
}
